import React, { useState } from "react";
import PropTypes from "prop-types";

import Select from "../select";
import SearchFilterAutoComplete from "./components/search-filter-auto-complete";
import SearchFilterAsyncAutoComplete from "./components/search-filter-async-auto-complete";
import SearchFilterInput from "./components/search-filter-input";
import styles from "./searchFilter.scss";

export const FILTER_TYPES = {
    INPUT: "INPUT",
    AUTOCOMPLETE: "AUTOCOMPLETE",
    ASYNC_AUTOCOMPLETE: "ASYNC_AUTOCOMPLETE",
};

function SearchFilter({
    searchType,
    onSearchTypeChange,
    searchTypeOptions,
    searchValue,
    onSearchValueChange,
    onEnter,
    filterOptions,
    placeholder,
    onSearchClick,
    variant,
    onSearchValueDropDownSelect,
    errors,
    touched
}) {
    const [autocompleteInput, setAutocompleteInput] = useState("");

    const searchTypeChange = (type) => {
        setAutocompleteInput("");
        onSearchTypeChange(type);
    };

    const renderFilter = () => {
        const type = searchType?.type ?? "";

        switch (type) {
            case FILTER_TYPES.AUTOCOMPLETE:
                return (
                    <SearchFilterAutoComplete
                        {...{
                            filterOptions,
                            searchType,
                            onSearchValueChange,
                            setAutocompleteInput,
                            autocompleteInput,
                        }}
                    />
                );
            case FILTER_TYPES.ASYNC_AUTOCOMPLETE:
                return (
                    <SearchFilterAsyncAutoComplete
                        {...{
                            filterOptions,
                            searchType,
                            onSearchValueDropDownSelect,
                            onSearchValueChange,
                            searchValue,
                        }}
                    />
                );
            default:
                return (
                    <SearchFilterInput
                        {...{
                            searchType,
                            onSearchValueChange,
                            searchValue,
                            searchTypeOptions,
                            placeholder,
                            onSearchClick,
                            onEnter,
                            errors,
                            touched
                        }}
                    />
                );
        }
    };

    return (
        <div className={`${styles.searchbox} ${styles[variant]} ${searchTypeOptions.length === 0 ? styles.search_rounded : null}`}>
            {searchTypeOptions.length > 0 && (
                <Select
                    value={searchType}
                    onChange={(type) => searchTypeChange(type)}
                    options={searchTypeOptions}
                    placeholder="Select"
                    label=""
                    required
                    name="filterType"
                />
            )}
            {renderFilter()}
        </div>
    );
}

SearchFilter.propTypes = {
    searchType: PropTypes.object,
    onSearchTypeChange: PropTypes.func,
    searchTypeOptions: PropTypes.array,
    searchValue: PropTypes.string,
    onSearchValueChange: PropTypes.func,
    filterOptions: PropTypes.object,
    placeholder: PropTypes.string,
    onSearchClick: PropTypes.func,
    variant: PropTypes.string,
};

SearchFilter.defaultProps = {
    placeholder: "Search Here",
    variant: "",
};

export default SearchFilter;
